module.exports = __webpack_public_path__ + "img/Christopher.581001b0.jpg";